import { render } from "./SchemaDetails.vue?vue&type=template&id=5ff8df17&scoped=true&ts=true"
import script from "./SchemaDetails.vue?vue&type=script&lang=ts"
export * from "./SchemaDetails.vue?vue&type=script&lang=ts"

import "./SchemaDetails.vue?vue&type=style&index=0&id=5ff8df17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff8df17"]])

export default __exports__